import { BaseSignalRConnection } from './base-signalr-connection';

class NamedEvents extends BaseSignalRConnection {
  constructor() {
    // Pass the URL specific to NamedEvents to the base class constructor
    super(process.env.REACT_APP_SIGNALR_NAMED_EVENTS_URL || '');
    this.init();
  }

  // Override the startConnection method to include NamedEvents-specific logic
  public async startConnection(): Promise<void> {
    await super.startConnection();

    // Register event listeners specific to NamedEvents after establishing the connection
    if (this.isConnected) {
      this._connection.on('Registered', (message: string) => {
        console.info('Registered event received:', message);
      });
    }
  }
  private async init(): Promise<void> {
    // if (process.env.NODE_ENV === 'development') {
    //   return;
    // }

    try {
      await this._connection.start();
      this._isConnected = true;
      this._connection.on('Registered', (message: string) => {
        console.info(message);
      });
    } catch (error) {
      this._isConnected = false;
    }
  }
}

export default new NamedEvents();
